import { Box, Slide, Typography } from '@material-ui/core';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackWithTitle from 'components/BackWithTitle/BackWithTitle';
import { RouteNames } from 'utils/navigationUtils';
import { isEmailValid } from 'utils/util';
import { AccountButton } from '../../../AccountButton/AccountButton';
import { AccountInput } from '../../../AccountInput/AccountInput';
import { AccountMobileHeader } from '../../../AccountMobileHeader/AccountMobileHeader';
import style from './ForgotPasswordPane.scss';

interface Props {
  sendEmail: Function;
  handleError: (err: any) => void;
  loadingState: [boolean, Dispatch<SetStateAction<boolean>>];
  handleExternalRouting?: Nullable<(url?: Nullable<string>) => void>;
}

export const ForgotPasswordPane: React.FC<Props> = ({ sendEmail, handleError, loadingState, handleExternalRouting }) => {
  const emailState: [string, Dispatch<SetStateAction<string>>] = useState<string>('');
  const [changed, setChanged] = useState<boolean>(false);
  const [emailAttempted, setEmailAttempted] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadingState[1](false);
  }, []);

  useEffect(() => {
    if (emailAttempted && isEmailValid(emailState[0])) {
      setEmailAttempted(false);
    }
  }, [emailAttempted, emailState[0]]);

  const submitEmail = () => {
    const email: string = emailState[0];
    if (!isEmailValid(email)) {
      setEmailAttempted(true);
      return;
    }
    if (handleExternalRouting) {
      handleExternalRouting();
    }
    navigate(RouteNames.FORGOT_PASSWORD_EMAIL, { state: { email }, replace: true });
  };

  const emailValidationMessage = (): string => (emailAttempted && !isEmailValid(emailState[0]) ? 'Please provide a valid email' : '');

  return (
    <React.Fragment>
      <Box className={style.inputBox}>
        <Box className={style.backButton}>
          <BackWithTitle title="Back to login" onClick={() => navigate(RouteNames.LOGIN)} />
        </Box>
        <AccountMobileHeader />
        <Slide direction="up" in={changed} mountOnEnter unmountOnExit>
          <Box>
            <Typography className={style.instructionHeader}>{`An email with instructions to reset your password has been sent to ${emailState[0]}`}</Typography>
            <Typography hidden={!changed} className={style.closeInstruction}>
              (You can close this tab)
            </Typography>
          </Box>
        </Slide>
        {!changed && (
          <React.Fragment>
            <Box>
              <Typography className={style.mainHeader}>Forgot password</Typography>
              <Typography className={style.instructionHeader}>Please enter your email.</Typography>
            </Box>
            <AccountInput inputState={emailState} placeholder="Email" includeValidation={true} validationMessage={emailValidationMessage()} cssClass={style.marginTop} />
            <AccountButton label="RESET PASSWORD" onClick={submitEmail} loading={loadingState[0]} cssClass={style.marginTop} />
          </React.Fragment>
        )}
      </Box>
    </React.Fragment>
  );
};
